<!--
 * @Descripttion: 手机号输入框
 * @FilePath: /mall-wap-vue/src/views/login/components/PhoneField/index.vue
 * @Author: 张兴业
 * @Date: 2020-10-09 14:26:09
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-12-22 21:48:35
-->
<template>
  <div class="phone_field">
    <div slot="label" class="prefix_menu">
      <div v-cloak v-clickoutside="outsideClose" class="dropmain">
        <div @click="show = !show" class="dropbutton">
          <span>{{ prefix }}</span>
          <van-icon name="arrow-down" class="prefix_icon" />
        </div>
        <div class="dropdown" v-show="show">
          <div
            v-for="(item, index) in options"
            :key="index"
            class="dropdown_item"
            @click="changePrefix(item)"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <van-field
      v-model="phone"
      name="phone"
      label-width="48px"
      clearable
      placeholder="请输入手机号"
      :class="phone ? 'phone' : 'phone_un'"
      @input="phoneChange"
      @clear="clear"
    />
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      phone: this.value,
      prefix: "+86",
      show: false,
      options: ["+86", "+61"]
    };
  },
  directives: {
    clickoutside: {
      bind(el, binding) {
        function documentHandler(e) {
          if (el.contains(e.target)) {
            return false;
          }
          if (binding.expression) {
            binding.value(e);
          }
        }

        function KeyUp(e) {
          if (e.keyCode == 27) {
            if (binding.expression) {
              binding.value(e);
            }
          }
        }
        el.__vueClickOutSize__ = documentHandler;
        el.__vueKeyup__ = KeyUp;

        document.addEventListener("keyup", KeyUp);
        document.addEventListener("click", documentHandler);
      },
      unbind(el) {
        document.removeEventListener("click", el.__vueClickOutSize__);
        delete el.__vueClickOutSize__;

        document.removeEventListener("keyup", el.__vueKeyup__);
        delete el.__vueKeyup__;
      }
    }
  },
  methods: {
    outsideClose() {
      this.show = false;
    },
    changePrefix(item) {
      this.prefix = item;
      this.show = false;
      this.$emit("prefixChange", item);
    },
    phoneChange(value) {
      this.$emit("input", value);
    },
    clear() {
      this.$emit("input", "");
    }
  }
};
</script>

<style lang="less" scoped>
.phone_field {
  display: flex;
  flex-direction: row;
  padding: 5px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);

  .prefix_menu {
    margin: auto 0;

    [v-cloak] {
      display: none;
    }

    .dropmain {
      width: 48px;
      position: relative;
    }

    .dropbutton {
      display: block;
      width: 48px;
      height: 32px;
      line-height: 32px;
      color: black;
      // background-color: #39f;
      text-align: center;
      font-size: 12px;
      font-weight: 600;
      // border-radius: 4px;
      cursor: pointer;
      outline: none;
      user-select: none;

      span {
        vertical-align: middle;
      }

      .prefix_icon {
        vertical-align: middle;
        margin-left: 2px;
      }
    }

    .dropdown {
      position: absolute;
      top: 32px;
      left: 0;
      width: 48px;
      font-size: 12px;
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
      text-align: left;
      margin-top: 2px;
      z-index: 1999;
    }

    .dropdown_item {
      height: 32px;
      line-height: 32px;
      padding-left: 6px;
      font-size: 12px;
      font-weight: 600;
    }
  }

  .phone {
    font-size: 16px;
    font-weight: 600;
  }

  .phone_un {
    font-size: 12px;
    font-weight: 400;
  }
}
</style>
